import { NextPage } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { i18n, SSRConfig } from 'next-i18next';
import { AppProps } from 'next/app';
import NotFoundPage from '@sy/app-client/src/ssrAdapter/pages/NotFoundPage';
import { logger } from '@sy/logger';

import type { DefaultContext } from '../getServerSideProps';

type NotFoundPageProps = AppProps & SSRConfig;

const Custom404: NextPage<NotFoundPageProps> = () => {
	return <NotFoundPage i18n={i18n} />;
};

export async function getStaticProps(context: DefaultContext) {
	try {
		return {
			props: {
				...(await getTranslationsForAllLocales(context)),
			},
		};
	} catch (error) {
		logger.error('NotFoundPage getServerSideProps failed', {
			error,
		});

		throw error;
	}
}

async function getTranslationsForAllLocales(context: DefaultContext) {
	const namespaces = ['common', 'auth'];
	try {
		return await serverSideTranslations(
			context.defaultLocale,
			namespaces,
			undefined,
			context.locales,
		);
	} catch (error) {
		logger.error('NotFoundPage getTranslationsForAllLocales failed', error);
	}
	return undefined;
}

export default Custom404;
